import React, { useEffect, useState } from "react";
import { X, Save, Edit2, Trash2, Unlock, Users, Plus } from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const AddUser = (props) => {
  const isEdit = props.mode === "edit";

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [editing, setEditing] = useState(!isEdit);

  const [name, setName] = useState(isEdit ? props.userEdit.name : "");
  const [mail, setMail] = useState(isEdit ? props.userEdit.mail : "");
  const [phone, setPhone] = useState(isEdit ? props.userEdit.phone : "");
  const [password, setPassword] = useState(
    isEdit ? props.userEdit.password : ""
  );
  const [role, setRole] = useState(isEdit ? props.userEdit.role : "user");
  const [company, setCompany] = useState("ALL");

  const [departs, setDeparts] = useState(
    isEdit
      ? props.userEdit.departs
        ? props.userEdit.departs.split(",").filter(Boolean)
        : []
      : []
  );
  const [departSelect, setDepartSelect] = useState(
    props.companies?.[0]?.name || ""
  );
  const [brandSelect, setBrandSelect] = useState(
    props.sources?.[0]?.name || ""
  );

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/getUsersList`, {
          method: "POST",
          headers: hdrs,
          body: "{}",
        });
        setUsers(await res.json());
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    })();
  }, []);

  const validate = () => {
    if (!name.trim() || !mail.trim() || !phone.trim() || !password.trim()) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
      return false;
    }
    return true;
  };

  const departsStr = () => departs.join(",");

  const handleSave = async () => {
    if (!validate()) return;
    const endpoint = isEdit ? "editUser" : "addUser";
    const body = {
      name,
      mail,
      phone,
      password,
      departs: departsStr(),
      role,
      comapny: "ALL",
      ...(isEdit ? { id: props.userEdit.id } : {}),
    };
    try {
      await fetch(`${API}/${endpoint}`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify(body),
      });
      MySwal.fire({
        icon: "success",
        title: "Użytkownik",
        text: isEdit ? "zmieniony" : "dodany",
      });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async () => {
    const model = {};
    users
      .filter(
        (u) =>
          u.name !== props.userEdit.name &&
          u.companies?.trim() === props.userEdit.companies?.trim()
      )
      .forEach((u) => {
        model[u.id] = u.name;
      });

    await fetch(`${API}/deleteUser`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({
        id: props.userEdit.id,
      }),
    });
    MySwal.fire({ icon: "success", title: "Użytkownik", text: "usunięty" });
    props.close();
  };

  const handleFreeLeads = () => {
    const model = {};
    (props.statuses || []).forEach((s) => {
      model[s.name] = s.name;
    });

    MySwal.fire({
      title: "Jaki status uwolnić?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wartość",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: (v) =>
        new Promise((res) => res(v ? undefined : "musisz wybrać wartość")),
    }).then(async (result) => {
      if (result.isConfirmed) {
        await fetch(`${API}/freeLeads`, {
          method: "POST",
          headers: hdrs,
          body: JSON.stringify({ id: props.userEdit.id, status: result.value }),
        });
        MySwal.fire({ icon: "success", title: "Leady", text: "zwolnione" });
        props.close();
      }
    });
  };

  const cancelEdit = () => {
    setEditing(false);
    setName(props.userEdit.name);
    setMail(props.userEdit.mail);
    setPhone(props.userEdit.phone);
    setPassword(props.userEdit.password);
    setDeparts(props.userEdit.departs.split(",").filter(Boolean));
    setRole(props.userEdit.role);
    setCompany(props.userEdit.companies);
  };

  const addDepart = () => {
    if (departSelect && !departs.includes(departSelect)) {
      setDeparts((prev) => [...prev, departSelect]);
    }
  };

  const removeDepart = (b) => setDeparts((prev) => prev.filter((x) => x !== b));

  if (loading) return <Loading />;

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal sn-modal--wide">
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Users size={18} />
            <h2 className="sn-title">
              {editing
                ? isEdit
                  ? "Edytuj użytkownika"
                  : "Dodaj użytkownika"
                : "Użytkownik"}
            </h2>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          <div className="scc-form-grid">
            <div className="rp-field">
              <label className="db-field-label">
                Nazwa <span className="scc-req">*</span>
              </label>
              <input
                type="text"
                className="db-input"
                disabled={!editing}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Adres e-mail <span className="scc-req">*</span>
              </label>
              <input
                type="email"
                className="db-input"
                disabled={!editing}
                value={mail}
                onChange={(e) => setMail(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Numer telefonu <span className="scc-req">*</span>
              </label>
              <input
                type="tel"
                className="db-input"
                disabled={!editing}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">
                Hasło <span className="scc-req">*</span>
              </label>
              <input
                type="text"
                className="db-input"
                disabled={!editing}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">Rola</label>
              <select
                className="db-input db-select"
                disabled={!editing}
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="user">Użytkownik</option>
                <option value="admin">Administrator</option>
              </select>
            </div>

            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">DZIAŁY</label>
              {editing && (
                <div className="au-brand-add">
                  <select
                    className="db-input db-select"
                    value={departSelect}
                    onChange={(e) => setDepartSelect(e.target.value)}
                    style={{ flex: 1 }}
                  >
                    {(props.companies || []).map((s) => (
                      <option key={s.name} value={s.name}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                  <button
                    className="lq-btn lq-btn--primary"
                    onClick={addDepart}
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    <Plus size={13} /> Dodaj
                  </button>
                </div>
              )}
              <div className="au-brand-tags">
                {departs.length === 0 && (
                  <span className="au-brand-empty">
                    Brak przypisanych działów
                  </span>
                )}
                {departs.map((b) => (
                  <span key={b} className="au-brand-tag">
                    {b}
                    {editing && (
                      <button
                        className="au-brand-remove"
                        onClick={() => removeDepart(b)}
                      >
                        ×
                      </button>
                    )}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="scc-form-footer">
            {editing && (
              <button className="lq-btn lq-btn--success" onClick={handleSave}>
                <Save size={14} /> {isEdit ? "Zapisz" : "Dodaj"}
              </button>
            )}

            {isEdit && !editing && (
              <button
                className="lq-btn lq-btn--primary"
                onClick={() => setEditing(true)}
              >
                <Edit2 size={14} /> Edytuj
              </button>
            )}

            {isEdit && editing && (
              <button className="lq-btn lq-btn--muted" onClick={cancelEdit}>
                Anuluj edycję
              </button>
            )}

            {isEdit && (
              <>
                <button
                  className="lq-btn lq-btn--primary"
                  onClick={handleFreeLeads}
                >
                  <Unlock size={14} /> Zwolnij leady
                </button>
                <button
                  className="lq-btn lq-btn--danger"
                  onClick={handleDelete}
                >
                  <Trash2 size={14} /> Usuń
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
